<template>
    <form-row title="Have You Secured Insurance Coverage?">
        <input-radio-boolean
            name="has_coverage"
            v-model="has_coverage"
            true="Yes"
            false="No"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        value: {},
        read_only: { default: false },
    },

    computed: {
        has_coverage: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
}
</script>
